import { render, staticRenderFns } from "./SubdivisionUpdate.vue?vue&type=template&id=1872734f"
import script from "./SubdivisionUpdate.vue?vue&type=script&lang=js"
export * from "./SubdivisionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports